
import Vue from 'vue';
import Modal from '@core/components/UI/Modal.vue';
import FormTextarea from '@core/components/UI/form/FormTextarea.vue';
import PianoCustomerStateHandler from '@piano/components/PianoCustomerStateHandler.vue';
import Service from '@root/common/base/Service';
import { faMessageExclamation, faCircleCheck } from '@delfi.lt/fa-kit/icons/modules/classic/regular';

interface Props {
  settings: Record<string, number>;
  articleData: {
    id: number;
    title: string;
    categoryName: string;
  };
}
interface Data {
  mistakeText: string;
  emptyCorrectionError: boolean;
  formSubmited: boolean;
}

interface Methods {
  toggleReportModal: () => void;
  submitMistake: () => void;
  logSubmission: (mistake: string | null, correction: string) => void;
}

interface Computed {
  isLoggedIn: boolean;
  isModalVisible: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Modal,
    FormTextarea,
    PianoCustomerStateHandler,
  },
  data() {
    return {
      mistakeText: '',
      emptyCorrectionError: false,
      formSubmited: false,
      faMessageExclamation,
      faCircleCheck,
    };
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    articleData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.piano.isLoggedIn;
    },
    isModalVisible() {
      return this.$store.state.article.mistakeReportVisible;
    },
  },
  watch: {
    isModalVisible: {
      handler(value) {
        if (typeof value !== 'undefined') {
          this.$nextTick(() => {
            if (process.client && window.getSelection()) {
              const selection = window.getSelection();
              if (selection && selection.type === 'Range') {
                this.mistakeText = selection.toString();
              }
            }
          });
        }
      },
    },
  },
  methods: {
    toggleReportModal() {
      this.$store.commit('article/toggleMistakeReport');
      this.formSubmited = false;
    },
    async submitMistake() {
      const mistake = (document.getElementById(`mistake-a-${this.articleData.id}`) as HTMLTextAreaElement)?.textContent || null;
      const correction = (document.getElementById(`correction-a-${this.articleData.id}`) as HTMLTextAreaElement)?.value || null;

      if (correction) {
        const service = new Service();
        const apiProvider = service.createProvider('HTTP');
        try {
          const response = await apiProvider.request<Response>({
            url: `/api/report-mistake`,
            method: 'post',
            data: { mistake, correction, articleId: this.articleData.id },
          });

          if (response.status === 202) {
            this.logSubmission(mistake, correction);
            this.formSubmited = true;
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        this.emptyCorrectionError = true;
      }
    },
    logSubmission(mistake, correction) {
      const params = {
        old_phrase: mistake,
        new_phrase: correction,
      };

      this.$event.send('report_error', params);
    },
  },
});
